export default "__VITE_ASSET___w3inn3o__"